module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM15 30h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1zm9-6H4V4h20v20z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/ipad-1.js
// module id = 1194
// module chunks = 14